import plugin from "tailwindcss/plugin";
import { PluginAPI } from "tailwindcss/types/config";
import { Themes } from "./themes";
import daisyui from "daisyui";
import "./components/";

// import alertStyles from "./components/alert/alert-styles";

const templwind = plugin.withOptions(
  (userThemes: Themes = {}) =>
    (api: PluginAPI) => {
      const { addComponents, theme } = api;
      const mergedThemes = { ...userThemes };

      // Use type assertion to add daisyui config
      (api.config as any).daisyui = {
        themes: [mergedThemes],
      };

      // Add your custom components
      // addComponents(alertStyles(theme));
    },
  () => ({
    plugins: [daisyui],
  })
);

export default templwind;

if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
  module.exports = templwind;
}
